import React, { useState } from "react";
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Button,
	FormControl,
	FormControlLabel,
	RadioGroup,
	Radio,
	TextField,
} from "@material-ui/core";
import intl from "react-intl-universal";

interface RenewLicenseDialogProps {
	open: boolean;
	onClose: () => void;
	onConfirm: (newDate: Date) => void;
}

export default function RenewLicenseDialog({
	open,
	onClose,
	onConfirm,
}: RenewLicenseDialogProps) {
	const [option, setOption] = useState<"month" | "custom">("month");
	const [customDate, setCustomDate] = useState<string>("");
	const [errors, setErrors] = useState<{ [key: string]: string }>({});

	const validate = () => {
		const newErrors: { [key: string]: string } = {};
		if (!customDate) {
            newErrors.expiresAt = intl.get("license.expiresAtRequired");
        } else {
            const expiresDate = new Date(customDate);
            const today = new Date();

            if (expiresDate <= today) {
                newErrors.expiresAt = intl.get("license.expiresAtValidation");
            }
        }
		setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
	}

	const handleConfirm = () => {
		if (option === "month") {
			const newDate = new Date();
			newDate.setMonth(newDate.getMonth() + 1);
			onConfirm(newDate);
		} else {
			if (!validate()) return;
			onConfirm(new Date(customDate));
		}
		onClose();
	};

	const handleCancel = () => {
		setErrors({});
		onClose();
	}

	return (
		<Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
			<DialogTitle>{intl.get("license.licenseRenew")}</DialogTitle>
			<DialogContent>
				<FormControl component="fieldset" style={{ width: "100%" }}>
					<RadioGroup
						value={option}
						onChange={(e) => setOption(e.target.value as "month" | "custom")}
						color="primary"
					>
					<FormControlLabel
						value="month"
						control={<Radio />}
						label={intl.get("license.increaseMonth")}
						style={{ marginBottom: 8 }}
					/>
					<FormControlLabel
						value="custom"
						control={<Radio color="primary" />}
						label={intl.get("license.specificDate")}
					/>
					</RadioGroup>
				</FormControl>

				{option === "custom" && (
					<TextField
						label={intl.get("license.expiresAt")}
						type="date"
						value={customDate}
						onChange={(e) => setCustomDate(e.target.value)}
						InputLabelProps={{ shrink: true }}
						style={{ marginTop: 16 }}
						error={!!errors.expiresAt}
						helperText={errors.expiresAt}
						fullWidth
					/>
				)}
				</DialogContent>
			<DialogActions>
				<Button 
					onClick={handleCancel}
					variant="outlined"
					color="secondary">
						{intl.get("license.cancel")}
				</Button>
				<Button 
					onClick={handleConfirm} 
					variant="contained"
					style={{ backgroundColor: "#00acc1", color: "#fff" }}>
					{intl.get("license.save")}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
